import Axios from '../plugins/axios'

export const uploadImage = function (formData) {
    return Axios.post('upload', formData);
}

export const uploadGallery = function (files) {
    return Axios.post('upload/gallery', files);
}

export const getGalleryFiles = function () {
    return Axios.get('upload/gallery');
}

export const deleteGalleryFile = function (id) {
    return Axios.delete(`upload/gallery/${id}`);
}